import { handleActions } from 'redux-actions';
import { selectNavItem } from '../actions';

const initialState = {
    activeNavItem: 'forms',
};

export default handleActions(
    {
        [selectNavItem]: (state, action) => ({
            ...state,
            activeNavItem: action.payload,
        }),
    },
    initialState,
);
